"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _customProps = require("../../../../utils/customProps");

var _customComponents = require("../../../../utils/customComponents");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var List = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/organisms/List/List"));
  });
});
var ListDropdown = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/organisms/ListDropdown/ListDropdown"));
  });
});
var components = {
  List: List,
  ListDropdown: ListDropdown
};

var Drawer = function Drawer(_ref) {
  var anchor = _ref.anchor,
      rootClass = _ref.rootClass,
      elevation = _ref.elevation,
      variant = _ref.variant,
      toggleDrawer = _ref.toggleDrawer,
      content = _ref.content,
      open = _ref.open,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;
  var width = '100%';
  if (anchor === 'left' || anchor === 'right') width = '32vw';

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, {
    minWidth: width
  }); // eslint-disable-next-line no-multi-assign


  var handleToggleDrawer = function handleToggleDrawer(event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    toggleDrawer(!open);
  };

  return /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    anchor: anchor,
    classes: {
      paper: styles.root
    },
    open: open,
    elevation: +elevation,
    variant: variant,
    onClose: function onClose(e) {
      return handleToggleDrawer(e);
    },
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, content.map(function (component, key) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, (0, _customComponents.renderComponentsWithBridge)(components, _objectSpread(_objectSpread({}, component), {}, {
      toggleDrawer: toggleDrawer
    }), key));
  }));
};

var _default = Drawer;
exports.default = _default;
Drawer.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui props: 'bottom', 'left', 'right', 'top'
   * Side from which the drawer will appear.
   */
  anchor: function anchor(props, propName, componentName) {
    var validProps = ['bottom', 'left', 'right', 'top'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * number
   * The elevation of the drawer.
   * storyblok type is a number
   */
  elevation: _propTypes.default.string,

  /**
   * mui props: 'permanent', 'persistent', 'temporary'
   * The variant to use.
   */
  variant: function variant(props, propName, componentName) {
    var validProps = ['permanent', 'persistent', 'temporary'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * components:
   * MuiList
   */
  content: function content(props, propName, componentName) {
    var components = ['MuiList', 'MuiListDropdown'];
    return (0, _customProps.validComponents)(props, propName, componentName, components);
  },

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  variant: 'temporary',
  rootClass: [],
  content: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};